module.exports = __webpack_public_path__ + "static/img/yo.aae7176b.png";